<p-dialog header="{{ taskAddEditHeader }}" [(visible)]="displayAddTask" (onHide)="dialogClose()" [modal]="true" [responsive]="true" [style]="{ width: '50vw' }">
    <div class="card">
        <form [formGroup]="taskDetailsForm" novalidate>
            <div class="p-grid">

                <div class="p-col-12 p-pb-0">
                    <div class="p-grid">
                        <div class="p-col-12 p-md-4">
                            <label>Task Type <span style="color: red;">*</span></label>
                        </div>
                        <div class="p-col-12 p-md-8 p-d-flex">
                            <div *ngFor="let c of taskTypes" class="p-mr-2">
                                <div class="p-field-checkbox p-mb-0">
                                    <p-radioButton [inputId]="c.id" name="taskTypeId" [value]="c.id"
                                        formControlName="taskTypeId" [disabled]="viewOnly || selectedActionTask?.id"></p-radioButton>
                                    <label [for]="c.id">{{c.name}}</label>
                                </div>
                            </div>
                            <div *ngIf="detailsFormErrors?.taskTypeId" class="p-invalid">
                                <small>{{ detailsFormErrors?.taskTypeId }}</small>
                            </div>
                        </div>
                    </div>
                </div>

                <ng-container *ngIf="taskDetailsForm.getRawValue().taskTypeId==1">
                    <div class="p-col-6 p-md-4">
                        <label>Assign Type</label>
                        <p-dropdown [options]="assignedTypes" formControlName="assignedType" appendTo="body" placeholder="Select Assing Type" optionLabel="name" [disabled]="viewOnly"></p-dropdown>

                        <div *ngIf="detailsFormErrors?.assignedType" class="p-invalid">
                            <small>{{ detailsFormErrors?.assignedType }}</small>
                        </div>
                    </div>

                    <div class="p-col-6 p-md-4">
                        <label>Assign To <span style="color: red;">*</span></label>
                        <!-- <p-dropdown [options]="activeUsers" formControlName="selectedUsers" optionLabel="name" placeholder="Select User" appendTo="body" [filter]="true" filterBy="name" [disabled]="viewOnly">
                            <ng-template let-user pTemplate="item">
                                <div class="user-item" [ngClass]="{'inactive-item': user.statusId == 2 }">
                                    <div>{{user.name}}</div>
                                </div>
                            </ng-template>
                        </p-dropdown> -->

                        <p-multiSelect [options]="activeUsers" formControlName="selectedUsers" optionLabel="name" placeholder="Select Users" appendTo="body" [disabled]="viewOnly">
                            <ng-template let-user pTemplate="item">
                                <div class="user-item" [ngClass]="{'inactive-item': user.statusId == 2 }">
                                    <div>{{user.name}}</div>
                                </div>
                            </ng-template>
                        </p-multiSelect>

                        <div *ngIf="detailsFormErrors?.selectedUsers" class="p-invalid">
                            <small>{{ detailsFormErrors?.selectedUsers }}</small>
                        </div>
                    </div>
                </ng-container>

                <div class="p-col-6 p-md-4">
                    <label>Shared Task With</label>
                    <p-multiSelect [options]="activeUsers" formControlName="selectedSharedWithUsers" optionLabel="name" placeholder="Select Users" appendTo="body" [disabled]="viewOnly">
                        <ng-template let-user pTemplate="item">
                            <div class="user-item" [ngClass]="{'inactive-item': user.statusId == 2 }">
                                <div>{{user.name}}</div>
                            </div>
                        </ng-template>
                    </p-multiSelect>

                    <div *ngIf="detailsFormErrors?.selectedSharedWithUsers" class="p-invalid">
                        <small>{{ detailsFormErrors?.selectedSharedWithUsers }}</small>
                    </div>
                </div>

                <div class="p-col-6 p-md-4">
                    <label>Task Category <span style="color: red;">*</span></label>
                    <p-dropdown
                        [options]="taskCategories"
                        formControlName="taskCategory"
                        appendTo="body"
                        placeholder="Select Task Category"
                        optionLabel="category.name"
                        [filter]="true"
                        filterBy="category.name"
                        [disabled]="viewOnly">
                         <ng-template pTemplate="footer">
                            <button type="button" pButton (click)="addNewCategory()" icon="pi pi-plus"
                                label="Add New Task Category" class="p-button-secondary footer-button"></button>
                        </ng-template>
                    </p-dropdown>

                    <div *ngIf="detailsFormErrors?.taskCategory" class="p-invalid">
                        <small>{{ detailsFormErrors?.taskCategory }}</small>
                    </div>
                </div>

                <div class="p-col-6 p-md-4">
                    <label>Reminder Type</label>
                    <p-dropdown [options]="reminderTypes" formControlName="reminderType" appendTo="body" placeholder="Select Reminder Type" optionLabel="name" [readonly]="true" [ngClass]="{'p-disabled': true}"></p-dropdown>

                    <div *ngIf="detailsFormErrors?.reminderType" class="p-invalid">
                        <small>{{ detailsFormErrors?.reminderType }}</small>
                    </div>
                </div>
                <div class="p-col-6 p-md-4">
                    <label>Reminder</label>
                    <p-dropdown [options]="reminderDelay" formControlName="reminder" appendTo="body" placeholder="Select Reminder" optionLabel="name" [disabled]="viewOnly"></p-dropdown>

                    <div *ngIf="detailsFormErrors?.reminder" class="p-invalid">
                        <small>{{ detailsFormErrors?.reminder }}</small>
                    </div>
                </div>

                <div class="p-col-6 p-md-4">
                    <label>Task Repeat</label>
                    <p-dropdown [options]="repeat" formControlName="repeatType" appendTo="body" placeholder="Select Repeat Type" optionLabel="name" [disabled]="viewOnly"></p-dropdown>

                    <div *ngIf="detailsFormErrors?.repeatType" class="p-invalid">
                        <small>{{ detailsFormErrors?.repeatType }}</small>
                    </div>
                </div>
                <div class="p-col-6 p-md-4">
                    <label>Priority</label>
                    <p-dropdown [options]="priority" (onChange)="changePriority($event)" formControlName="priority" appendTo="body" placeholder="Select Priority" optionLabel="name" [disabled]="viewOnly"></p-dropdown>

                    <div *ngIf="detailsFormErrors?.priority" class="p-invalid">
                        <small>{{ detailsFormErrors?.priority }}</small>
                    </div>
                </div>

                <ng-container *ngIf="taskDetailsForm.getRawValue().taskTypeId==1">
                    <div class="p-col-6  p-md-3">
                        <label>Due Days <span style="color: red;">*</span></label>

                        <input type="number" [min]="taskDetailsForm.getRawValue().startDateAddOrSubstractValue" formControlName="endDateAddOrSubstractValue" pInputText placeholder="Enter Task End Days" [disabled]="viewOnly"/>

                        <div *ngIf="detailsFormErrors?.endDateAddOrSubstractValue" class="p-invalid">
                            <small>{{ detailsFormErrors?.endDateAddOrSubstractValue }}</small>
                        </div>
                    </div>
                </ng-container>

                <div class="p-col-12">
                    <label>Task Title</label>

                    <input type="text" formControlName="taskTitle" pInputText placeholder="Enter Task Title" [disabled]="viewOnly"/>

                    <div *ngIf="detailsFormErrors?.taskTitle" class="p-invalid">
                        <small>{{ detailsFormErrors?.taskTitle }}</small>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="taskDetailsForm.getRawValue().taskTypeId==1">
                <div class="p-grid">
                    <div class="p-col-12">
                        <label>Task Details <span style="color: red;">*</span></label>
                        <textarea formControlName="description" rows="5" pInputTextarea [disabled]="viewOnly"></textarea>

                        <div *ngIf="detailsFormErrors?.description" class="p-invalid">
                            <small>{{ detailsFormErrors?.description }}</small>
                        </div>
                    </div>
                </div>
            </ng-container>

            <ng-container *ngIf="taskDetailsForm.getRawValue().taskTypeId==2">
                <div class="p-grid">
                    <div class="p-col-12">
                        <div class="p-d-flex p-jc-between">
                            <div class="p-d-flex">
                                <label>Task List: </label>
                                <div class="p-field-checkbox p-mb-0 p-ml-3">
                                    <p-checkbox [binary]="true" [formControl]="taskDetailsForm.controls.isTaskOrdered" inputId="binary" [disabled]="viewOnly"></p-checkbox>
                                    <label for="binary">Task Order</label>
                                </div>
                            </div>
                            <p-button *ngIf="!viewOnly" icon="pi pi-plus" pTooltip="Add Task" tooltipPosition="top" (onClick)="addEditGroupTask()"></p-button>
                        </div>
                        <div *ngIf="groupChildTasks?.length==0 && groupTaskErrorMsg" class="p-invalid">
                            <small>{{ groupTaskErrorMsg }}</small>
                        </div>
                        <ul style="margin-left: -38px;" cdkDropList [cdkDropListData]="groupChildTasks"
                            (cdkDropListDropped)="dragNDrop($event)">
                            <div *ngFor="let task of groupChildTasks;let groupIndex=index;" cdkDrag [cdkDragDisabled]="viewOnly">
                                <div class="p-d-flex task-box colList p-px-0 p-mb-2">
                                    <div style="flex-grow: 1;">
                                        <div class="task-header p-d-flex p-jc-between  p-p-2">
                                            <div class="p-d-flex">
                                                <div><span class="p-mr-1">{{ groupIndex + 1 }}<strong>.</strong></span> {{ task.workflowActionChildTaskAssignees[0]?.name }}</div>
                                            </div>
                                            <div class="p-d-flex">
                                                <div class="task-time">Due Days: {{ task.endDateAddOrSubstractValue }}</div>
                                                <span *ngIf="!viewOnly" class="btnBars p-ml-2" (click)="addEditGroupTask(task,groupIndex)" pTooltip="Edit" tooltipPosition="top">
                                                    <i class="pi pi-pencil"></i>
                                                </span>
                                                <span *ngIf="!viewOnly" class="btnBars" (click)="removeGroupTask(groupIndex)" pTooltip="Edit" tooltipPosition="top">
                                                    <i class="pi pi-trash"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="p-p-2 task-content"><div [innerHTML]="task.description"></div></div>
                                    </div>
                                </div>
                                <p-divider styleClass="custom-divider" type="dashed"></p-divider>
                            </div>
                        </ul>
                    </div>
                </div>
            </ng-container>


            <div class="p-grid">
                <div class="p-col-12">
                    <label for="upload">Attachments(Max Size 2MB)  <i class="pi pi-exclamation-circle" [escape]="false"
                        [pTooltip]="multiLineTooltip" tooltipPosition="top"></i></label>

                    <p-fileUpload customUpload="true" class="fupload" previewWidth="100" chooseLabel="Choose Files" [multiple]="true" [showUploadButton]="false" [showCancelButton]="false" [disabled]="viewOnly"
                        (onSelect)="uploadAttachments($event.files)">
                        <ng-template pTemplate="file"></ng-template>
                        <ng-template pTemplate="content">
                            <ng-container *ngFor="let attachmentDetails of attachments;let i=index;">
                                <ng-container *ngIf="attachmentDetails.statusId === 1">
                                    <div class="p-fileupload-row">
                                        <button type="button" pButton icon="fa fa-download"
                                            (click)="downloadFile(attachmentDetails.displayFileName, attachmentDetails?.attachment?.content, attachmentDetails?.attachment?.id)"
                                            class="p-button-link p-px-0 p-py-0" label="">
                                        </button>
                                        <div [ngClass]="{'p-fileupload-link': !!(attachmentDetails?.attachment?.id>0)}">
                                            <ng-container *ngIf="attachmentDetails.displayFileName.length>50 else splitImageName">
                                                <div (click)="openFileNewTab(attachmentDetails?.attachment)">{{ attachmentDetails.displayFileName.substring(0, 50) }}...</div>
                                            </ng-container>
                                            <ng-template #splitImageName>
                                                <div (click)="openFileNewTab(attachmentDetails?.attachment)">{{ attachmentDetails.displayFileName }}</div>
                                            </ng-template>
                                        </div>

                                        <div style="width: 100px; max-width: 100px;">{{ (attachmentDetails.fileSize / 1024).toFixed(2) + ' KB' }}</div>
                                        <div style="width: 100px; max-width: 100px;" *ngIf="!viewOnly">
                                            <button icon="pi pi-times" pButton (click)="removeAttachment(attachmentDetails,i)" type="button"></button>
                                        </div>
                                    </div>
                                </ng-container>
                            </ng-container>
                        </ng-template>
                    </p-fileUpload>

                </div>
            </div>
        </form>
    </div>
    <p-footer>
        <button type="button" pButton (click)="dialogClose()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="!viewOnly" type="submit" pButton (click)="saveTask()" label="Save"></button>
    </p-footer>
</p-dialog>


<p-dialog [header]="groupTaskHeader" [modal]="true" [maximizable]="false" [responsive]="true"
    [(visible)]="displayGroupTaskAddEdit" [style]="{width: '40vw'}">
    <form [formGroup]="groupTaskDetailsForm">
        <div class="card">
            <div class="task-box">
                <div class="p-grid">
                    <div class="p-col-6">
                        <label>Assign To <span style="color: red;">*</span></label>
                        <p-dropdown [options]="activeUsers" formControlName="selectedUsers" optionLabel="name" placeholder="Select User" appendTo="body" [filter]="true" filterBy="name" [disabled]="viewOnly">
                            <ng-template let-user pTemplate="item">
                                <div class="user-item" [ngClass]="{'inactive-item': user.statusId == 2 }">
                                    <div>{{user.name}}</div>
                                </div>
                            </ng-template>
                        </p-dropdown>

                        <div *ngIf="groupDetailsFormErrors?.selectedUsers" class="p-invalid">
                            <small>{{ groupDetailsFormErrors?.selectedUsers }}</small>
                        </div>
                    </div>

                    <div class="p-col-6">
                        <label>Due Days <span style="color: red;">*</span></label>

                        <input type="number" [min]="0" formControlName="endDateAddOrSubstractValue" pInputText placeholder="Enter Task End Days" [disabled]="viewOnly"/>

                        <div *ngIf="groupDetailsFormErrors?.endDateAddOrSubstractValue" class="p-invalid">
                            <small>{{ groupDetailsFormErrors?.endDateAddOrSubstractValue }}</small>
                        </div>
                    </div>
                </div>
                <div>
                    <p-editor #editor [style]="{'height':'100px'}" formControlName="description">
                        <p-header>
                            <span class="ql-formats">
                                <select class="ql-size">
                                    <option value="small">small</option>
                                    <option selected></option>
                                    <option value="large">large</option>
                                    <option value="huge">huge</option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <select class="ql-size">
                                    <option value="24px">24</option>
                                    <option value="48px">48</option>
                                    <option value="100px">100</option>
                                    <option value="200px">200</option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-bold" aria-label="Bold"></button>
                                <button class="ql-italic" aria-label="Italic"></button>
                                <button class="ql-underline" aria-label="Underline"></button>
                                <button class="ql-strike" aria-label="Strike"></button>
                            </span>
                            <span class="ql-formats">
                                <select title="Text Color" class="ql-color"></select>
                                <span class="ql-format-separator"></span>
                                <select title="Background Color" class="ql-background"></select>
                            </span>
                            <span class="ql-formats">
                                <button class="ql-list" value="ordered"></button>
                                <button class="ql-list" value="bullet"></button>
                                <select title="Text Alignment" class="ql-align">
                                    <option selected>Gauche</option>
                                    <option value="center" label="Center"></option>
                                    <option value="right" label="Right"></option>
                                    <option value="justify" label="Justify"></option>
                                </select>
                            </span>
                            <span class="ql-formats">
                                <button aria-label="Link" class="ql-link"></button>
                            </span>
                        </p-header>
                    </p-editor>
                    <div *ngIf="groupDetailsFormErrors?.description" class="p-invalid">
                        <small>{{ groupDetailsFormErrors?.description}}</small>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="displayGroupTaskAddEdit=false;" label="Cancel" class="p-button-secondary"></button>
        <button pButton (click)="saveGroupTask()" label="Save"></button>
    </ng-template>
</p-dialog>

<p-dialog *ngIf="displayAddTaskCategory" header="Add New Task Category" [modal]="true" [responsive]="true"
    [(visible)]="displayAddTaskCategory" [style]="{width: '50vw'}">
    <form [formGroup]="addTaskCategoryForm">
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <label for="categoryName">Name <span style="color: red;">*</span></label>
                    <input (keyup)="validateNewTaskCategory()" formControlName="categoryName" type="text" pInputText>
                    <div *ngIf="categoryDetailsFormErrors?.categoryName" class="p-invalid">
                        <small>{{ categoryDetailsFormErrors?.categoryName }}</small>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="cancelNewTaskCategory()" label="Cancel" class="p-button-secondary"></button>
        <button pButton [loading]="isLoadingInputNewTaskCategoryName" (click)="saveNewTaskCategory()"
            label="Save"></button>
    </ng-template>
</p-dialog>
